<template>
    <el-container class="h-100 w-100 bg-ff">
      <el-aside width="120px">
        <div class="aside-top"></div>
        <div class="title">客户详情</div>
        <div class="menu">
          <div :class="{'menuActive' : index === menuIndex}" v-for="(item, index) in menu" :key="index">
            <span class="cursor" @click="toPage(index)">{{item.name}}</span>
          </div>
        </div>
      </el-aside>
      <el-main class="flex-column">
        <div class="customerInfo flex align-center justify-space-between">
          <div class="flex align-center">
            <div>
              <div><span>楼盘小区：</span>{{info.name}}</div>
              <div><span>装修风格：</span>{{info.telephone}}</div>
            </div>
            <div class="line"></div>
            <div>
              <div><span>户<i style="display: inline-block; height: 1px; width: 2em;"></i>型：</span>{{info.detailedAddress}}</div>
              <div><span>建筑面积：</span>{{info.projectContractNo}}</div>
            </div>
            <div class="line"></div>
            <div>
              <div><span>使用面积：</span></div>
              <div><span style="letter-spacing: 1.5px;">设 计 师：</span></div>
            </div>
            <div class="line"></div>
            <div>
              <div style="height: 32px;"><span>项目经理：</span></div>
            </div>
          </div>
          <div class="close flex align-center justify-center cursor" @click="onClose">
            <i class="el-icon-close font-18-ff"></i>
          </div>
        </div>
        <div class="flex-column flex-1 bg-f3f4f7">
          <effect-pic ref="effectPic" :customerId="id" :picHeight="picHeight" v-if="menuIndex === 0"></effect-pic>
          <realistic-pic ref="realisticPic" :customerId="id" :picHeight="picHeight" v-if="menuIndex === 1"></realistic-pic>
          <construction-management ref="constructionManagement" :customerId="id" :picHeight="picHeight" v-if="menuIndex === 2"></construction-management>
        </div>
      </el-main>
    </el-container>
</template>

<script>
import EffectPic from './components/EffectPic'
import RealisticPic from './components/RealisticPic'
import ConstructionManagement from './components/ConstructionManagement'
export default {
  name: 'caseDetail',
  components: {EffectPic, RealisticPic, ConstructionManagement},
  data () {
    return {
      id: null,
      parent: null,
      permission: [],
      info: {},
      menu: [{
        name: '效果图',
        path: 'DetailInfo',
        permission: ''
      }, {
        name: '实景图',
        path: 'PlanToRemind',
        permission: 'plan'
      }, {
        name: '工地管理',
        path: 'Drawings',
        permission: 'file'
      }],
      menuIndex: 0,
      picHeight: null
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    // this.parent = this.$route.query.parent
    this.getInfo()
  },
  methods: {
    // getPermission () {
    //   this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
    //     parent: 'customerFunction',
    //     parentGroup: 'customerFunction'
    //   }).then(res => {
    //     if (res.data.success) {
    //       this.permission = res.data.data.split(',')
    //     }
    //   })
    // },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.$refs.effectPic.getPic()
        }
      })
    },
    toPage: function (index) {
      this.menuIndex = index
    },
    onClose () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-aside{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .el-main{
    padding: 0;
  }
  .aside-top{
    height: 5px;
    background: #f5971d;
    width: 100%;
  }
  .el-aside .title{
    background: #f3f4f7;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-weight: bold;
    font-size: 18px;
    color: #30313a;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .menu > div{
    color: #30313a;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: dashed 1px #e2e2e2;
  }
  .menu > .menuActive{
    background: #f5971d;
    color: #fff;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/successfulCases/caseDetail.vue